/* eslint-disable no-empty */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import OrderNumbers from './Components/OrderNumbers';
import OtherInformation from './Components/OtherInformation';
import PlantWise from './Components/PlantWise';
import { distributorService } from '../../service/distributor.service';
import CreateDirectOrderPopup from '../ManageApprovedOrders/Components/CreateDirectOrderModal';
import DashboardSkeleton from './dashboardSkeleton';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function Dashboard() {
    const [dashboardData, setDashboardData] = useState({});
    const [plantWiseData, setPlantWiseData] = useState([]);
    const [plantWiseHasAccess, setPlantWiseHasAccess] = useState(false);
    const [directOrderPopup, setDirectOrderPopup] = useState(false);
    const [selected, setSelected] = useState('DAILY');
    const [customDate, setCustomDate] = useState(false);
    const [loading, setLoading] = useState(false);
    const [triggerApi, setTrigger] = useState('DAILY');
    const [selectedDate, setselectedDate] = useState({
        start_date: '',
        end_date: '',
    });

    // commenting the old dashboard code(may be required to debug)

    // const handleFetch = useCallback(async () => {
    //     let date;
    //     if (selectedDate?.start_date && selectedDate?.end_date) {
    //         date = `${moment(selectedDate.start_date).format('DD-MM-YYYY')},${moment(selectedDate.end_date).format('DD-MM-YYYY')}`;
    //     }
    //     setLoading(true);
    //     const data = await distributorService.dashboardValues(date, selected);
    //     if (data.data.success_status === true && data.data.data.length > 0) {
    //         setLoading(false);
    //         setDashboardData(data.data.data[0]);
    //         if (date) {
    //             setSelected('CUSTOM');
    //         }
    //     }
    //     setLoading(false);
    // }, [triggerApi]);

    const handleFetch = useCallback(async () => {
        let date;
        if (selectedDate?.start_date && selectedDate?.end_date) {
            date = `${moment(selectedDate.start_date).format('DD-MM-YYYY')},${moment(selectedDate.end_date).format('DD-MM-YYYY')}`;
        }
        setLoading(true);
        const keys = ['APPROVED_VALUE',
            'AVG_VALUE',
            'DIRECT_VALUE',
            'EUB_VALUE',
            'TRADE_VALUE',
            'VALUE',
            'POSTGRES_QUERIES',
        ]; // 7 keys to call
        const apiCalls = keys.map((key) => distributorService.dashboardValues(date, selected, key) // trigger API call
            .then((response) => {
                // Handle successful response immediately and update the respective section
                if (response.error) {
                    // eslint-disable-next-line no-console
                    console.error(`${key} failed: ${response.message}`);
                } else {
                    setDashboardData((prevData) => ({
                        ...prevData,
                        ...response?.data?.data[0],
                    }));
                }
            })
            .catch((error) => {
                // Handle error immediately
                // eslint-disable-next-line no-console
                console.error(`${key} API call failed:`, error);
            }));

        // All calls are now fired at once, each responding when ready
        try {
            await Promise.all(apiCalls); // Wait for all promises to settle (not blocking UI though)
            if (date) {
                setSelected('CUSTOM');
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error while waiting for all API calls:', error);
        }

        const plantWiseResponse = await distributorService.plantWiseDashboard(date, selected);
        if (!plantWiseResponse.error && plantWiseResponse.data?.success_status) {
            setPlantWiseData(plantWiseResponse.data.data || []);
            setPlantWiseHasAccess(plantWiseResponse.data.has_access || false);
        }

        setLoading(false);
    }, [triggerApi]);
    useEffect(() => {
        document.body.style.overflow = 'unset';
        handleFetch();
    }, [handleFetch]);

    const previlegeassigned = AccessPrevilegesFunction('orders:create_direct_order');

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center">
                <h5 className="text-xs4 font-normal text-[#555259]">Dashboard</h5>
                {previlegeassigned === true
                    ? (
                        <button type="button" className="bg-[#555259] font-bold text-xs h-9 text-white  py-1 px-4 rounded-[9px]" onClick={() => setDirectOrderPopup(true)}>
                            Create Direct Order
                        </button>
                    ) : null}
            </div>
            {loading ? <DashboardSkeleton />
                : (
                    <div>
                        <OrderNumbers dashboardData={dashboardData} setselectedDate={setselectedDate} selectedDate={selectedDate} selected={selected} setSelected={setSelected} handleFetch={handleFetch} customDate={customDate} setCustomDate={setCustomDate} triggerApi={triggerApi} setTrigger={setTrigger} />
                        {/* <OtherInformation dashboardData={dashboardData} /> */}
                        <PlantWise data={plantWiseData} hasAccess={plantWiseHasAccess} />
                        {directOrderPopup && <CreateDirectOrderPopup directOrderPopup={directOrderPopup} setDirectOrderPopup={setDirectOrderPopup} />}
                    </div>
                )}
        </div>

    );
}

export default Dashboard;
